document.addEventListener("DOMContentLoaded", function () {
  const shippingInfo = document.querySelector(".product__title-price-shipping-info");
  const countryInput = document.querySelector(
    '.localization-form input[name="country_code"]'
  );
  const countryCode = countryInput.value;

  if (countryCode !== "US") {
    shippingInfo.style.display = "none";
  } else {
    shippingInfo.style.display = "";
  }

});
